import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  useIsMobile,
} from '@design-system';
import { AddPartnerForm, useAddPartner, type AddPartnerFormValues } from '@/features/add-partner';

interface AddPartnerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clientId: string;
  onSubmitSuccess?: (data: PostAddPartnerResponse) => void;
}

export function AddPartnerDialog({
  open,
  onOpenChange,
  clientId,
  onSubmitSuccess,
}: AddPartnerDialogProps) {
  const isMobile = useIsMobile();
  const { addPartner, isPending } = useAddPartner({
    clientId,
    onSuccess: data => {
      onOpenChange(false);
      onSubmitSuccess?.(data);
    },
  });

  function handleSubmit(data: AddPartnerFormValues) {
    addPartner(data);
  }

  const title = 'Add Partner';
  const description =
    "Enter your partner's basic details to include them in your plan.";

  if (!isMobile) {
    return (
      <Dialog
        open={open}
        onOpenChange={onOpenChange}
      >
        <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          <AddPartnerForm
            onSubmit={handleSubmit}
            isSubmitting={isPending}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
    >
      <DrawerContent className="max-h-[90vh] overflow-y-auto px-4 pb-6">
        <DrawerHeader className="text-left">
          <DrawerTitle>{title}</DrawerTitle>
          <DrawerDescription>{description}</DrawerDescription>
        </DrawerHeader>
        <AddPartnerForm
          onSubmit={handleSubmit}
          isSubmitting={isPending}
        />
      </DrawerContent>
    </Drawer>
  );
}
